import axiosApi from "./ajaxToAxios";
import { allowedLocales } from "scripts/utils/constants";

// export const getFilialByCity = ({ id, locale = "en", options = [] }) => {
//   return $.ajax({
//     url: `${BASE_URL}/api/cart`,
//     type: "GET",
//     cache: false,
//     // data: `product_variant_id=${id},options=['service-name_loss']`,
//     data: {
//       product_variant_id: id,
//       options,
//     },
//     // contentType: "application/json; charset=utf-8",
//     dataType: "json",
//     headers: {
//       "Accept-Language": locale,
//     },
//     success: (response) => response,
//     error: (error) => {
//       console.log(error)
//     },
//   })
// }
let currentLocale = document.documentElement.lang || "en";
if (!(currentLocale in allowedLocales)) {
  currentLocale = allowedLocales.uk;
}

export const getFilialByCity = (cityCode, locale = currentLocale) => {
  return axiosApi.get({
    url: `/${locale}/api/filial/get-filial-by-city?city_code=${cityCode}`,
  })
}

export const checkout = (data, locale = currentLocale) => {
  return axiosApi.post({
    url: `/api/checkout`,
    data: JSON.stringify(data),
    contentType : "application/json",
    headers: {
      "Accept-Language": locale,
    },
  })
}